(function () {
  var form = document.getElementById('trix-pw-form');
  if (!form) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var wrap = document.getElementById('trix-pw-wrap');
  var done = document.getElementById('trix-pw-done');
  var err = form.querySelector('[data-error]');
  var btn = form.querySelector('button[type="submit"]');
  var lbl = form.querySelector('[data-label]');
  var defaultLabel = lbl ? lbl.textContent : 'Reserve my size';

  function post(fields) {
    var fd = new FormData();
    fd.append('utf8', '✓');
    Object.keys(fields).forEach(function (k) {
      fd.append(k, fields[k]);
    });
    return fetch(ROOT + 'contact', { method: 'POST', body: fd, headers: { Accept: 'text/html' } });
  }

  function slug(v) {
    return String(v).toLowerCase().replace(/[^a-z0-9]+/g, '-');
  }

  function fail(msg) {
    err.textContent = msg;
    err.hidden = false;
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    err.hidden = true;

    var email = form.email.value.trim();
    var size = form.size.value;

    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return fail('Enter a valid email address.');
    if (!size) return fail('Choose your size.');

    btn.disabled = true;
    if (lbl) lbl.textContent = 'Sending...';

    try {
      await post({
        form_type: 'customer',
        'contact[email]': email,
        'contact[tags]': 'sizing-list,size-' + slug(size)
      });

      await post({
        form_type: 'contact',
        'contact[email]': email,
        'contact[Size]': size,
        'contact[body]': 'SIZING LIST SIGNUP -- Email: ' + email + ' | Size: ' + size
      });

      if (wrap) wrap.hidden = true;
      if (done) {
        done.hidden = false;
        var d = done.querySelector('[data-done-body]');
        if (d) d.textContent = 'You are on the list for a ' + size + '. We will email you before the drop goes live.';
      }
    } catch (x) {
      btn.disabled = false;
      if (lbl) lbl.textContent = defaultLabel;
      fail('Something went wrong. Please try again.');
    }
  });
})();
